import * as Yup from "yup";

const Validation = Yup.object({
  localeCode: Yup.string().required("Please select Language!"),
  languageName: Yup.string().required("Please enter name for selected language!"),
});

export default Validation;
